import { render, staticRenderFns } from "./listaPdvsEvento.vue?vue&type=template&id=3c8681f0&scoped=true&"
import script from "./listaPdvsEvento.vue?vue&type=script&lang=js&"
export * from "./listaPdvsEvento.vue?vue&type=script&lang=js&"
import style0 from "./listaPdvsEvento.vue?vue&type=style&index=0&id=3c8681f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8681f0",
  null
  
)

export default component.exports